module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[17]16.b6c464d.woff2";